import Drupal from 'drupal';
import once from 'once';

const SIDENAV_SELECTOR = '.usa-sidenav';
const SUBNAV_TOGGLE_SELECTOR = '.accordion-toggle';
const SIDEBAR_TOGGLE_SELECTOR = '#sidenav-title, #sidebar-title, #filter-title';
const TOGGLE_SELECTOR = `${SIDEBAR_TOGGLE_SELECTOR}, ${SIDENAV_SELECTOR} ${SUBNAV_TOGGLE_SELECTOR}`;
const ACTIVE_TRAIL_SELECTOR = '.sideNav-active';

const expandedState = new Map();

const getControlledElement = toggle => {
  const controls = toggle.getAttribute('aria-controls');
  return controls
    ? document.getElementById(controls)
    : toggle.nextElementSibling;
};

const getStateKey = toggle =>
  toggle.getAttribute('aria-controls') || toggle.id || null;

const setExpanded = (toggle, expanded) => {
  const controlledElement = getControlledElement(toggle);
  const stateKey = getStateKey(toggle);

  toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

  if (controlledElement) {
    controlledElement.hidden = !expanded;
  }

  if (stateKey) {
    expandedState.set(stateKey, expanded);
  }
};

const toggleExpanded = toggle => {
  setExpanded(toggle, toggle.getAttribute('aria-expanded') !== 'true');
};

const getInitialExpanded = toggle => {
  const stateKey = getStateKey(toggle);

  if (stateKey && expandedState.has(stateKey)) {
    return expandedState.get(stateKey);
  }

  return toggle.getAttribute('aria-expanded') === 'true';
};

const getDirectChild = (element, selector) =>
  Array.from(element.children).find(child => child.matches(selector));

const revealItem = item => {
  const sublist = getDirectChild(item, 'ul');
  const toggle = getDirectChild(item, SUBNAV_TOGGLE_SELECTOR);

  if (toggle) {
    toggle.setAttribute('aria-current', 'true');
    setExpanded(toggle, true);
  } else if (sublist) {
    sublist.hidden = false;
  }
};

const revealActiveTrail = sidenav => {
  const activeItems = Array.from(
    sidenav.querySelectorAll(`li${ACTIVE_TRAIL_SELECTOR}`)
  );

  activeItems.forEach(activeItem => {
    revealItem(activeItem);

    let parentItem = activeItem.parentElement.closest('.usa-sidenav__item');
    while (parentItem) {
      revealItem(parentItem);
      parentItem = parentItem.parentElement.closest('.usa-sidenav__item');
    }
  });
};

const initToggle = toggle => {
  const controlledElement = getControlledElement(toggle);

  if (!controlledElement) {
    return;
  }

  setExpanded(toggle, getInitialExpanded(toggle));

  toggle.addEventListener('click', event => {
    event.preventDefault();
    event.stopPropagation();

    toggleExpanded(toggle);
  });
};

const initSideNav = sidenav => {
  revealActiveTrail(sidenav);
};

Drupal.behaviors.sidenav = {
  attach(context) {
    once('hhsds-sidenav-nav', SIDENAV_SELECTOR, context).forEach(initSideNav);
    once('hhsds-sidenav-toggle', TOGGLE_SELECTOR, context).forEach(initToggle);
  },
};
